import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "../../../../shared/shared.module";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { ReferencesComponent } from "./references.component";
import { MatIconModule } from "@angular/material/icon";
@NgModule({
  declarations: [
    ReferencesComponent
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    SharedModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    ReferencesComponent
  ]
})
export class ReferencesModule { }